import React from 'react';
import {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { post, get, checkHttpStatus } from '../../utils/RestUtilsWithAxios';
import Paper from '@material-ui/core/Paper';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DownloadButtons from '../../components/PdfAndExcelDownloadButtons';
import PropTypes from 'prop-types';
import { GET_INVESTOR_PLATFORM_LIST } from '../../constants/uri';
import {printThisPage,stableSort,getSorting} from '../../utils/ExportUtils';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import {EXPORT_EXCEL_ACCOUNTS_BY_PLATFORM} from '../../constants/uri'
import * as DownloadUtils from "../../utils/downloadUtils";
import * as Globals from "../../constants/globals";

/**
 * desc
 * @param a
 * @param b
 * @param orderBy
 * @return {number}
 */
function desc(a, b, orderBy) {
    if (orderBy !== 'openDate') {
        return b[orderBy].toString().localeCompare(a[orderBy].toString());
    }
    else {
        if (a[orderBy] == null && b[orderBy] != null)
            return 1;
        else if (a[orderBy] != null && b[orderBy] == null)
            return -1;
        else if (a[orderBy] == null && b[orderBy] == null)
            return 0;
        else {
            const dateIndices = [6, 7, 8, 9, 3, 4, 0, 1];
            var r = 0;
            for (var i = 0; i < dateIndices.length; i++) {
                r = a[orderBy].charCodeAt(dateIndices[i]) - b[orderBy].charCodeAt(dateIndices[i]);
                if (r !== 0)
                    return r;
            }
            return r;
        }
    }
}

/**
 * stableSort
 * @param array
 * @param cmp
 */
function stableSortTable(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

/**
 * getSorting
 * @param order
 * @param orderBy
 * @return {function(*=, *=): number}
 */
function getSortingTable(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headStyles = makeStyles(theme => ({
    headFont: {
        fontSize: 13,
        fontWeight: 600
    },
    fontBold: {
        fontWeight: 600
    }
}));

/**
 * EnhancedTableHead
 * @param props
 * @return {*}
 * @constructor
 */
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const headClasses = headStyles();

    const headRows = [
        { id: 'platformBusinessName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_NAME" }) },
        { id: 'platformTitle', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_TITLE" }) }
    ];

    return (
        <TableHead>
            <TableRow>
                {headRows.map(row => (
                    <TableCell
                        key={row.id}
                        align={row.numeric ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === row.id ? order : false}
                        className={headClasses.headFont}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                        >
                            {
                                row.secondLabel ?
                                    <div>
                                        {row.label}<br />
                                        <Typography classes={{ subtitle1: headClasses.fontBold }} variant="subtitle1">{row.secondLabel}</Typography>
                                    </div>
                                    :
                                    <div>{row.label}</div>
                            }
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    fontSize13: {
        fontSize: 13
    },
    link: {
        color:'#aa3323'
    },
        infoMsg: {
        marginBottom: theme.spacing(2),
        margin:'auto',
        padding: 30
    },
}));

const useMainStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        marginBottom: theme.spacing(2),
        margin:'auto',
        padding: 30,
        paddingTop:20
    }, 
}))

/**
 * AccountsByPlatforms
 * @param props
 * @return stableSort(setArray,getSorting("asc",0))
 * @constructor
 */
function AccountsByPlatforms (props) {
    const mainClasses = useMainStyles();
    const [accInfoList, setAccInfoList] = useState([]);
    const [fade, setFade] = useState(false);

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('platformBusinessName');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);       

    /**
     * handleRequestSort
     * @param event
     * @param property
     */
    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }

    /**
     * handleChangePage
     * @param event
     * @param newPage
     */
    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    /**
     * handleChangeRowsPerPage
     * @param event
     */
    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

        /**
     * prepareItemArr
     * @param trArray
     * @return {setArray}
     */
    function prepareItemArr(trArray) {
        var setArray = [];
        for(var i=0;i<trArray.length;i++){
            var valueItem = {};
            valueItem.values = [];
            valueItem.values.push(trArray[i].platformBusinessName);
            valueItem.values.push(trArray[i].platformTitle);
            setArray.push(valueItem);
        }
        return stableSort(setArray,getSorting("asc",0));
    }    

    const headRows = [
        { id: 'platformBusinessName', numeric: false, disablePadding: false, label: props.intl.
            formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_NAME" }) },
        { id: 'platformTitle', numeric: false, disablePadding: false, label: props.intl.
            formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_TITLE" }) }
    ];

    useEffect(()=>{
        var postData = {};
        postData['mbrId'] = null;
        get(GET_INVESTOR_PLATFORM_LIST)
        .then(function (response) {
            console.log(response.data);
            setAccInfoList(response.data);
            setFade(true);
        })
        .catch(function (error) {
            checkHttpStatus(error,props.intl);
        })
    },[]);

    /**
     * downloadAsExcel
     * @param serviceName
     * @param fileName
     */
    function downloadAsExcel(requesyBody) {
        post(EXPORT_EXCEL_ACCOUNTS_BY_PLATFORM,requesyBody)
            .then(function (response) {
                DownloadUtils.downloadFileByContentExcel(response.data, "KRİPTO VARLIK HESAPLARIM RAPORU.xls", Globals.CONTENT_TYPE_EXCEL);
        })
        .catch(function (error) {
            checkHttpStatus(error,props.intl);
        })
    }

    return (
        <div className={mainClasses.root}>
            <Paper className={mainClasses.paper} >
                <Fade in={fade} timeout={100}>
                    {
                        accInfoList.length > 0 ?
                        <div>
                           <div className={classes.tableWrapper} id="accountTable">
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    size={'medium'}
                                >
                                    <EnhancedTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={accInfoList.length}
                                        intl={props.intl}
                                    />
                                    <TableBody>
                                        {stableSortTable(accInfoList, getSortingTable(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={'row' + index}
                                                    >
                                                        <TableCell align="left" key={"platformCode_" + index} id={"platformCode_" + index} className={classes.fontSize13}>{row.platformBusinessName}</TableCell>
                                                        <TableCell align="left" key={"platformTitle_" + index} id={"platformTitle_" + index} className={classes.fontSize13}>{row.platformTitle}</TableCell>
                                                    </TableRow>    
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </div>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={accInfoList.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonText={props.intl.formatMessage({ id: "TABLE.PAGINATION.PREVIOUS" })}
                                nextIconButtonText={props.intl.formatMessage({ id: "TABLE.PAGINATION.NEXT" })}
                                labelRowsPerPage={props.intl.formatMessage({ id: "TABLE.PAGINATION.PER_PAGE" })}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        
                        
                        </div>
                        :
                        <Typography variant="subtitle1">{"Herhangi bir platformda hesabınız bulunmamaktadır."}</Typography>
                    }
                </Fade>
            </Paper>
            { accInfoList.length > 0 &&
            <DownloadButtons
                pdfOnClick={() =>  { printThisPage(
                                      prepareItemArr(
                                        accInfoList
                                      ),
                                      headRows,
                                      "Kripto Varlık Hesaplarım" 
                                    )}
                }
                excelOnClick={() =>  downloadAsExcel(accInfoList)
                }
            />
            }
            <Paper className={classes.infoMsg}>
                <Grid container style={{backgroundColor: "white"}}>
                    <Typography display="inline" variant="subtitle1">
                        {"Bu sayfada yer alan bilgiler, ilgili platformlar tarafından MKK'ya iletilen verilerden oluşmaktadır. Uyumsuzluk durumunda verilerin düzeltilmesi için ilgili kripto varlık platformuna başvurabilirsiniz."}
                    </Typography>
                </Grid>
            </Paper>
        </div>
    )
}

/**
 * injectIntl
 */
export default injectIntl(
    connect(
      null,
    )(AccountsByPlatforms)
);